var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('console-content', {
    attrs: {
      "max-width": "1024"
    }
  }, [_c('v-row', {
    staticClass: "mt-3 mt-md-8 px-1",
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    staticClass: "tit tit--lg",
    attrs: {
      "cols": "auto"
    }
  }, [_vm.banner._id ? _c('span', [_vm._v("배너 상세")]) : _c('span', [_vm._v("배너 등록")])]), _c('v-spacer')], 1), _c('v-row', {
    staticClass: "mt-3"
  }, [_c('v-col', {
    staticClass: "py-0 pr-md-1",
    attrs: {
      "cols": "12",
      "md": "8"
    }
  }, [_c('v-card', {
    staticClass: "mx-1",
    attrs: {
      "disabled": !_vm.$hasScope(['root', 'admin'])
    }
  }, [_c('v-card-title', {
    staticClass: "tit tit--xs font-weight-bold"
  }, [_vm._v("기본정보")]), _c('v-card-text', [_c('v-row', [_c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "제목",
      "persistent-placeholder": "",
      "hide-details": ""
    },
    model: {
      value: _vm.banner.subject,
      callback: function callback($$v) {
        _vm.$set(_vm.banner, "subject", $$v);
      },
      expression: "banner.subject"
    }
  })], 1), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "url",
      "persistent-placeholder": "",
      "hide-details": ""
    },
    model: {
      value: _vm.banner.url,
      callback: function callback($$v) {
        _vm.$set(_vm.banner, "url", $$v);
      },
      expression: "banner.url"
    }
  })], 1)], 1), _c('v-row', {
    staticClass: "mt-4"
  }, [_c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "순서",
      "persistent-placeholder": "",
      "hide-details": ""
    },
    model: {
      value: _vm.banner.no,
      callback: function callback($$v) {
        _vm.$set(_vm.banner, "no", $$v);
      },
      expression: "banner.no"
    }
  })], 1), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.typeItems,
      "label": "타입",
      "persistent-placeholder": "",
      "hide-details": ""
    },
    model: {
      value: _vm.banner.type,
      callback: function callback($$v) {
        _vm.$set(_vm.banner, "type", $$v);
      },
      expression: "banner.type"
    }
  })], 1)], 1)], 1)], 1)], 1), _c('v-col', {
    staticClass: "py-0 pl-md-1",
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-card', {
    staticClass: "mx-1 mt-3 mt-md-0",
    attrs: {
      "disabled": !_vm.$hasScope(['root', 'admin'])
    }
  }, [_c('v-card-title', [_c('span', {
    staticClass: "tit tit--xs"
  }, [_vm._v("url 속성(내부 / 외부)")]), _c('v-spacer'), _c('v-switch', {
    staticClass: "mt-0",
    attrs: {
      "hide-details": ""
    },
    model: {
      value: _vm.banner.isUrl,
      callback: function callback($$v) {
        _vm.$set(_vm.banner, "isUrl", $$v);
      },
      expression: "banner.isUrl"
    }
  })], 1)], 1)], 1)], 1), _c('v-card', {
    staticClass: "mt-4 mx-1",
    attrs: {
      "disabled": !_vm.$hasScope(['root', 'admin'])
    }
  }, [_c('v-card-title', {
    staticClass: "tit tit--xs font-weight-bold"
  }, [_vm._v("배너 이미지")]), _c('v-card-text', [_c('v-layout', {
    attrs: {
      "no-gutters": "",
      "align-center": ""
    }
  }, [_vm.image ? _c('v-img', {
    attrs: {
      "src": _vm.image,
      "max-width": "96",
      "height": "auto",
      "contain": ""
    }
  }) : _c('v-sheet', {
    attrs: {
      "width": "96",
      "height": "96",
      "color": "d-flex justify-center align-center grey lighten-2"
    }
  }, [_c('v-icon', [_vm._v("mdi-image")])], 1), _c('v-file-input', {
    model: {
      value: _vm.banner.image,
      callback: function callback($$v) {
        _vm.$set(_vm.banner, "image", $$v);
      },
      expression: "banner.image"
    }
  })], 1)], 1)], 1), _c('v-row', {
    staticClass: "my-6"
  }, [_c('v-spacer'), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-btn', {
    attrs: {
      "disabled": !_vm.$hasScope(['root', 'admin']),
      "color": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("저장")])], 1), _c('v-spacer')], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }